import React from "react";
import { LazyLoadImage, LineDots } from "../../../../../../core/atoms";

import "./enquiryHeader.scss";

export interface Props {
  children?: React.ReactNode;
  locationImage?: string;
  locationName?: string;
}

export const EnquiryHeader = ({  children, locationImage, locationName }: Props) => {
  return (
    <div className="enquiry-header columns">
      <div className="enquiry-header__inner-wrapper column is-10-desktop is-offset-2-desktop">
        <div className="enquiry-header__location-image-wrapper">
          <LazyLoadImage className="enquiry-header__location-image" src={locationImage} alt={locationName} />
          <LineDots height="30" x1="50%" y1="20%" x2="50%" y2="100%"/>
        </div>
        <div className="enquiry-header__heading-wrapper">
          <h1 className="enquiry-header__heading">Your trip {locationName ? `to ${locationName}`: ``}</h1>
          <LineDots height="30" x1="50%" y1="20%" x2="50%" y2="100%"/>
        </div>
      </div>
      {children}
    </div>
  );
};
